
import { supabase } from '@/integrations/supabase/client';

export const createDebugService = () => {
  // Função para debug - pode ser chamada manualmente
  const debugConnection = async () => {
    try {
      const { data, error } = await supabase.functions.invoke('uazapi-integration', {
        body: {
          action: 'debug_connectivity'
        }
      });

      if (error) throw error;
      
      console.log('Debug results:', data);
      return data;
    } catch (error: any) {
      console.error('Debug error:', error);
      throw error;
    }
  };

  return {
    debugConnection
  };
};
